<div class="container main-container">
  @if (tareas && tareas.length > 0) {
    @if (tareasAsignadasAlUsuario && tareasAsignadasAlUsuario.length > 0) {
      <h4 class="section-title">Tareas asignadas al usuario</h4>
      <div class="task-container">
        @for (nuevaTarea of tareasAsignadasAlUsuario; track $index) {
          @if($index>0){
            <mat-divider style="border-top-color: var(--mat-card-outlined-outline-color); margin: 0px 8px;"></mat-divider>
          }
          <div class="row task-actions-bar">
            <mat-card-header style="padding-top: 0px;padding-left: 38px;">
              <!--<mat-card-title >Tarea</mat-card-title>-->
              <mat-card-subtitle ><span style="font-weight: 500;">Tarea:</span> {{nuevaTarea.comentarios.at(0)!.comentario}}</mat-card-subtitle>
            </mat-card-header>
            <span class="sgd-spacer"></span>

              <span class="sgd-spacer"></span>
              <div style="display: flex; gap:0.5rem">
                @if (hasParticipated && isOwner) {
                @if (nuevaTarea.estado === 0) {
                  <button type="button" matTooltip="Redacta un documento" mat-stroked-button (click)="redactar(nuevaTarea)">
                    <mat-icon class="material-symbols-outlined">
                      stylus_note
                    </mat-icon>
                    Redactar
                  </button>
                    <button mat-icon-button matTooltip="Añadir anexo" aria-label="Añadir anexo" (click)="openDlgAnexos(nuevaTarea)">
                        <mat-icon>
                            <span class="material-symbols-outlined">
                                add_notes
                            </span>
                        </mat-icon>
                    </button>
                    <button mat-icon-button matTooltip="Comentar" aria-label="Comentar" (click)="opendDlgComentarTarea(nuevaTarea)">
                        <mat-icon>add_comment</mat-icon>
                    </button>
                    <button mat-icon-button matTooltip="Avance" aria-label="Avance"
                        (click)="opendDlgAvances(nuevaTarea)">
                        <mat-icon class="material-symbols-outlined">clock_loader_80</mat-icon>
                    </button>
                    <button mat-icon-button matTooltip="Finalizar" aria-label="Finalizar" (click)="opendDlgFinalizarTarea(nuevaTarea)">
                        <mat-icon>task</mat-icon>
                    </button>
                    <!--<button mat-icon-button matTooltip="Tarea hija" aria-label="Tareas hijas">
                        <mat-icon>post_add</mat-icon>
                    </button>-->
                    }
                    @if(nuevaTarea.estado === 1){
                    <button mat-icon-button matTooltip="Reabrir" aria-label="Comentar" (click)="opendDlgReabrirTarea(nuevaTarea)">
                        <mat-icon>cached</mat-icon>
                    </button>
                    }
                }
                </div>
        </div>
        <div class="row" style="padding-bottom: 1rem;">
            <div class="col-sm-12 col-md-6 col-xl-5">
                <mat-card appearance="outlined">
                    <mat-card-header>
                        <div mat-card-avatar><mat-icon class="material-symbols-outlined">account_circle</mat-icon></div>
                        <mat-card-title>Asignado por:</mat-card-title>
                        <mat-card-subtitle>
                            {{nuevaTarea.usuario}}
                        </mat-card-subtitle>
                    </mat-card-header>
                </mat-card>
            </div>
            <div class="col-sm-12 col-md-6 col-xl-3">
              <mat-card appearance="outlined">
                <mat-card-header style="width: 100%;">
                    <div mat-card-avatar><mat-icon class="material-symbols-outlined">clock_loader_20</mat-icon></div>
                    <mat-card-title style="width: 100%;">Avance: {{nuevaTarea.avance}}% - {{nuevaTarea?.estado||0 | subestadoTarea}}</mat-card-title>
                    <mat-card-subtitle class="avances-container" >
                        <mat-progress-bar mode="determinate" value={{nuevaTarea.avance}}  style="padding-top: 5px;"/><br>
                    </mat-card-subtitle>
                </mat-card-header>
            </mat-card>
            </div>
            <div class="col-sm-12 col-md-6 col-xl-4">
                <mat-card appearance="outlined">
                    <mat-card-header style="width: 100%;">
                        <div mat-card-avatar><mat-icon  class="material-symbols-outlined">event</mat-icon></div>
                        <mat-card-title>Fecha máxima:</mat-card-title>
                        <mat-card-subtitle>
                          @if (nuevaTarea.fechaExpira) {
                          {{formatDate(nuevaTarea.fechaExpira)}}
                            <mat-icon class="{{getSemaforoTarea(nuevaTarea)}} material-symbols-outlined"
                            style="line-height: 18px; float: inline-end;">fiber_manual_record</mat-icon>
                          }@else {
                          Sin fecha máxima
                          }
                      </mat-card-subtitle>
                    </mat-card-header>
                </mat-card>
            </div>
            <div class="col-12">
              <mat-expansion-panel togglePosition="before" displayMode="flat" style="margin: 2px 8px 0px 8px;">
                  <mat-expansion-panel-header>
                      <mat-card-header style="padding-top: 0;height: 24px; padding-left: 8px;">
                          <div mat-card-avatar><mat-icon class="material-symbols-outlined">comment</mat-icon></div>
                          <mat-card-subtitle>Recorrido de la tarea:</mat-card-subtitle>
                      </mat-card-header>
                  </mat-expansion-panel-header>
                  <mat-list>
                  @for (comentario of nuevaTarea.comentarios; track $index) {
                    <mat-list-item>
                      <mat-icon matListItemIcon class="material-symbols-outlined">line_start_circle</mat-icon>
                      <span matListItemTitle>{{comentario.comentario}}</span>
                      <span matListItemLine>{{formatDateTime(comentario.fecha)}}</span>
                    </mat-list-item>
                  }
                  </mat-list>
                  <!--<ul style="padding: 0; margin: 0; padding-left: 1rem;">
                      @for (comentario of nuevaTarea.comentarios; track $index) {
                      <li>{{comentario.comentario}}</li>
                      }
                  </ul>-->
              </mat-expansion-panel>
      </div>
        </div>
        }
    </div>
    }
    @if (tareasAsignadasPorUsuarioOtrosUsuarios && tareasAsignadasPorUsuarioOtrosUsuarios.length > 0) {
      <h4 class="section-title">Tareas asignadas a otros por el usuario</h4>
      <div class="task-container">
        @for (nuevaTarea of tareasAsignadasPorUsuarioOtrosUsuarios; track $index) {
          @if($index>0){
            <mat-divider style="border-top-color: var(--mat-card-outlined-outline-color); margin: 0px 8px;"></mat-divider>
          }
          <div class="row task-actions-bar">
              <mat-card-header style="padding-top: 0px;padding-left: 38px;">
                <!--<mat-card-title >Tarea</mat-card-title>-->
                <mat-card-subtitle ><span style="font-weight: 500;">Tarea:</span> {{nuevaTarea.comentarios.at(0)!.comentario}}</mat-card-subtitle>
              </mat-card-header>
              <span class="sgd-spacer"></span>
              <div style="display: flex; gap:0.5rem">
                @if (hasParticipated&& isOwner) {
                    @if (nuevaTarea.estado === 0) {
                    <button mat-icon-button matTooltip="Comentar" aria-label="Comentar" (click)="opendDlgComentarTarea(nuevaTarea)">
                        <mat-icon>add_comment</mat-icon>
                    </button>
                    <button mat-icon-button matTooltip="Cancelar" aria-label="Cancelar" (click)="opendDlgCancelarTarea(nuevaTarea)">
                        <mat-icon>
                            <span class="material-symbols-outlined">
                                scan_delete
                            </span>
                        </mat-icon>
                    </button>
                    }
                    @if(nuevaTarea.estado === 2){
                    <button mat-icon-button matTooltip="Reabrir" aria-label="Reabrir" (click)="opendDlgReabrirTarea(nuevaTarea)">
                        <mat-icon>cached</mat-icon>
                    </button>
                    }
                }
              </div>
          </div>
        <div class="row" style="padding-bottom: 1rem;">
            <div class="col-sm-12 col-md-6 col-xl-5">
                <mat-card appearance="outlined">
                    <mat-card-header>
                        <div mat-card-avatar><mat-icon  class="material-symbols-outlined">account_circle</mat-icon></div>
                        <mat-card-title>Asignado a:</mat-card-title>
                        <mat-card-subtitle>
                            {{nuevaTarea.asignado}}
                        </mat-card-subtitle>
                    </mat-card-header>
                </mat-card>
            </div>
            <div class="col-sm-12 col-md-6 col-xl-3">
              <mat-card appearance="outlined">
                  <mat-card-header style="width: 100%;">
                      <div mat-card-avatar><mat-icon class="material-symbols-outlined">clock_loader_20</mat-icon></div>
                      <mat-card-title style="width: 100%;">Avance: {{nuevaTarea.avance}}% - {{nuevaTarea?.estado||0 | subestadoTarea}}</mat-card-title>
                      <mat-card-subtitle class="avances-container" >
                          <mat-progress-bar mode="determinate" value={{nuevaTarea.avance}}  style="padding-top: 5px;"/><br>
                      </mat-card-subtitle>
                  </mat-card-header>
              </mat-card>
          </div>
            <div class="col-sm-12 col-md-6 col-xl-4">
                <mat-card appearance="outlined">
                    <mat-card-header>
                        <div mat-card-avatar><mat-icon  class="material-symbols-outlined">event</mat-icon></div>
                        <mat-card-title>Fecha máxima:</mat-card-title>
                        <mat-card-subtitle>
                            @if (nuevaTarea.fechaExpira) {
                            {{formatDate(nuevaTarea.fechaExpira)}}
                            <mat-icon class="{{getSemaforoTarea(nuevaTarea)}} material-symbols-outlined"
                              style="line-height: 18px; float: inline-end;">fiber_manual_record</mat-icon>
                            }@else {
                            Sin fecha máxima
                            }
                        </mat-card-subtitle>
                    </mat-card-header>
                </mat-card>
            </div>
            <div class="col-12">
                    <mat-expansion-panel togglePosition="before" displayMode="flat" style="margin: 2px 8px 0px 8px;">
                        <mat-expansion-panel-header>
                            <mat-card-header style="padding-top: 0;height: 24px; padding-left: 8px;">
                                <div mat-card-avatar><mat-icon class="material-symbols-outlined">comment</mat-icon></div>
                                <mat-card-subtitle class="material-symbols-outlined">Recorrido de la tarea:</mat-card-subtitle>
                              </mat-card-header>
                        </mat-expansion-panel-header>
                        <mat-list>
                        @for (comentario of nuevaTarea.comentarios; track $index) {
                          <mat-list-item>
                            <mat-icon matListItemIcon class="material-symbols-outlined">line_start_circle</mat-icon>
                            <span matListItemTitle>{{comentario.comentario}}</span>
                            <span matListItemLine>{{formatDateTime(comentario.fecha)}}</span>
                          </mat-list-item>
                        }
                        </mat-list>
                    </mat-expansion-panel>
            </div>
        </div>
        }
    </div>
    }
    }
</div>
